export { DMS_MODULE, AKCNI_PRODEJ_ND_POLOZKY as NAME, NAME as AKCNI_PRODEJ_ND } from '../constants';
export const CRUMB_LABEL_KEY = 'edtAkcniProdej';
export const ROW_ID_COLUMN = 0;
export const ROW_TEXT_COLUMN = 3;
